import styled from 'styled-components';
import breakpoints from '../../breakpoints';
import { Link as LinkRouter } from '@reach/router';

const trackingToLetterSpacing = (spacing) => `${spacing / 1000}em`;

export const ExpandedNav = styled.section`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  height: 185px;
  width: 100%;
  top: 84px;
  background-color: #F1F1F1;
  border: 1px solid #ccc;
  transition: 0.5s;
  z-index: 1;
  overflow-x: hidden;
`

export const Portfolio = styled.div`
  position: relative;
  padding: 20px;
  top: 0;
  &:before {
    content: '';
    position: absolute;
    right: 0;
    top: 25px;
    height: 125px;
    width: 1px;
    border-right: 1px solid #ccc;
    ${breakpoints('tablet')} {
      height: 155px;
      top: 15px;
    }
  }
  &:last-child:before {
    border-right: none;
  }
  ${breakpoints('tablet')} {
    padding: 5px;
  }
`
export const Title = styled(LinkRouter)`
  font-size: 14px;
  height: 15px;
  line-height: 45px;
  text-transform: uppercase;
  text-decoration: underline;
  color: black;
  &:visited{
    color: black;
  }
  &:hover {
    color: #CC0000;
  }
  &:active {
    color: #CC0000;
  }
`
export const List = styled.ul`
  margin-top: -16px;
  padding: 9px 0 0 0;
  list-style-type: none;
  
`
export const ExpandSectionIcon = styled.img`
  transform: ${({ isOpen }) => isOpen ? 'rotateX(180deg)' : ''};
  transition: transform .3s ease-in-out;
`

export const ListItem = styled.li`
  font-family:'ToyotaType Book';
  padding: 5px 0 5px 0;
  font-size: 14px;
  line-height: 24px;

`
export const PortfoliosButton = styled.span`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  display: flex;
  text-decoration: none;
  letter-spacing: ${trackingToLetterSpacing(50)};
  color: inherit;
  align-items: center;
  margin-right: 10px;
  padding: 30px 20px 30px 20px;
  ${breakpoints('tablet', 'up')} {
    font-size: 16px;
    line-height: 24px; 
  }
  background-color: ${({ isOpen }) => isOpen ? '#F1F1F1' : '#FFFFFF'};
  &:hover {
    text-decoration: underline;
    color: #CC0000;
    cursor: pointer;
  }
`
